import { User, Bot, Settings } from "lucide-react"

export const accountIcons = {
  user: <User className="h-4 w-4" />,
  bot: <Bot className="h-4 w-4" />,
  settings: <Settings className="h-4 w-4" />,
}
